import { Images } from "./data/images";
import { Icons } from "./data/icons";
import { Videos } from "./data/videos";

// Re-export named assets for convenience and to maintain existing imports
export { Images, Icons, Videos };

// Export types derived from the asset objects
export type IconKey = keyof typeof Icons;
export type ImageKey = keyof typeof Images;

// Default export Images as per previous implementation
export default Images;
